import $ from 'jquery';
import React from 'react';
import { renderRoot, unmountRoot } from '../../lib/react_root';
import SMSSingleUserConversation from '../../components/SMSSingleUserConversation';
import loadData from '../../lib/bootstrapped_data';

const AdministrationDrivers = {
  init() {
    this.initSmsMessenger();
    this.initDriverForm();
  },

  teardown() {
    const smsContainer = window.document.getElementById('js-sms-user-view');
    if (smsContainer) {
      unmountRoot(smsContainer);
    }

    $('.js-driver-last-name').off('blur', this.generateDriverUserName);
  },

  initSmsMessenger() {
    const smsContainer = window.document.getElementById('js-sms-user-view');
    if (!smsContainer) return;

    const conversation = loadData('conversation');
    const timezone = loadData('timezone');
    renderRoot(<SMSSingleUserConversation conversation={conversation} timezone={timezone} />, smsContainer);
  },

  initDriverForm() {
    const lastName = $('.js-driver-last-name');

    if (!lastName.length) return;

    lastName.on('blur', this.generateDriverUserName);
  },

  generateDriverUserName() {
    const firstName = $('.js-driver-first-name');
    const lastName = $('.js-driver-last-name');
    const userName = $('.js-driver-username');

    if (userName.val() !== '') return;

    const generatedName = `${firstName.val()}${lastName.val()}`.replace(/\W/gi, '').toLowerCase();
    userName.val(generatedName);
  }
}

export default AdministrationDrivers;
